/* eslint-disable no-template-curly-in-string */
import { object, string } from 'yup';

export const placeValidationSchema = object().shape({
    name: string()
        .min(1, ('Too Short!'))
        .max(10, 'Too Long!')
        .required('Required'),
});
